module.exports = __webpack_public_path__ + "img/plans.0c260de.svg";